export const logMappingStudioEvent = (
  event: string,
  payload: Record<string, unknown> = {},
) => {
  // Structured debug log for command reconciliation and rollout monitoring.
  // eslint-disable-next-line no-console
  console.info("[mapping-studio]", event, payload);
};
